// com.sds.sflex.common.system.dvo.ErrorInfoDVO에 정의되어 있는 ERROR_TYPE
const ERROR_TYPE = {
    BIZ: "B",
	EXCEPTION: "E",
	REDIRECT: "R",
	SESSION_EXPIRED: "S",
	OAUTH_EXPIRED: "O",
	UNSUPPORTED_DEVICE: "D",
	LOGIN: "L",
  };
  
  export default ERROR_TYPE;
  